const topics = [
  { name: '暑期档大战', heat: '9.8万', icon: 'ri-fire-line', color: 'text-primary-500' },
  { name: '新剧开播', heat: '8.5万', icon: 'ri-tv-line', color: 'text-accent-500' },
  { name: '综艺名场面', heat: '7.2万', icon: 'ri-emotion-laugh-line', color: 'text-primary-500' },
  { name: '明星日常', heat: '6.9万', icon: 'ri-star-line', color: 'text-accent-500' },
  { name: '影视盘点', heat: '6.1万', icon: 'ri-film-line', color: 'text-primary-500' },
  { name: '吃瓜速递', heat: '5.8万', icon: 'ri-flashlight-line', color: 'text-accent-500' },
  { name: '恋情曝光', heat: '5.3万', icon: 'ri-heart-line', color: 'text-primary-500' },
  { name: '颁奖典礼', heat: '4.9万', icon: 'ri-award-line', color: 'text-accent-500' },
  { name: '路透直击', heat: '4.5万', icon: 'ri-camera-line', color: 'text-primary-500' },
  { name: '音乐现场', heat: '3.8万', icon: 'ri-music-line', color: 'text-accent-500' },
  { name: '时尚穿搭', heat: '3.2万', icon: 'ri-t-shirt-line', color: 'text-primary-500' },
];

export default function TopicsSection() {
  return (
    <section id="topics" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-10 md:mb-14">
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-3">
              热门话题
            </h2>
            <p className="text-sm md:text-base text-foreground-500 max-w-xl mx-auto">
              当前最火爆的吃瓜话题，看看大家都在聊什么
            </p>
          </div>

          <div className="flex flex-wrap justify-center gap-3">
            {topics.map((topic) => (
              <div
                key={topic.name}
                className="group flex items-center gap-3 bg-background-100 hover:bg-background-200 border border-background-200/70 rounded-xl px-4 py-3 cursor-pointer transition-all duration-200 hover:scale-[1.02]"
              >
                <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-50">
                  <i className={`${topic.icon} text-lg ${topic.color}`}></i>
                </div>
                <div>
                  <span className="block text-sm font-medium text-foreground-800 whitespace-nowrap">
                    #{topic.name}
                  </span>
                  <span className="block text-xs text-foreground-500 whitespace-nowrap">
                    热度 {topic.heat}
                  </span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}